<template>
    <div>
        <div v-if="label" class="text-xs font-light opacity-80">Distance</div>
        <div :class="label ? 'mt-1' : ''" class="flex items-center">
            <i class="fa-solid fa-home text-xs mr-1"></i>
            <hr style="border: none; border-top: 1px dotted #000; color: #fff; background-color: #fff; height: 1px; width: 10px;">
            <span class="text-xs font-light mx-1">{{distance}}</span>
            <hr style="border: none; border-top: 1px dotted #000; color: #fff; background-color: #fff; height: 1px; width: 10px;">
            <i class="fa-solid fa-map-pin text-xs ml-1"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {default: true},
        distance: {required: true}
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SavDistance.vue